import http from '@/axios/http'
import { getuser_id } from "@/localStorage/localStorage";

//异常设备列表
export function getUncertainDeviceList() {
    const data = {
        user_id: getuser_id(),
        offset: 1,
        limit: 10
    }
    return http({
        url: '/api/uncertainDevice/getUncertainDeviceList',
        method: 'post',
        data
    })
}

//恢复设备
export function recoverUncertainDevice(device_id) {
    const data = {
        user_id: getuser_id(),
        device_id: device_id
    }
    return http({
        url: '/api/uncertainDevice/recoverUncertainDevice',
        method: 'post',
        data
    })
}

//查询排序
export function queryKeyword(keyword, offset, limit, sort) {
    const data = {
        user_id: getuser_id(),
        keyword: keyword,
        offset: offset,
        limit: limit,
        sn: sort.deviceSn,
        name: sort.deviceName,
        version: sort.deviceSoftwareVer,
        update: sort.deviceUpdate
    }
    return http({
        url: '/api/uncertainDevice/queryKeyword',
        method: 'post',
        data
    })
}